
export enum PaymentType {
    ACCOUNT = 1,
    CARD = 2
}
